import React, { useState } from 'react';
import Layout from '../components/Layout';
import Carousel from '../components/Carousel';
import { galleryPhotos } from '../data/photography';

function Fun() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const familyImages = [
    { src: "/aboutMe/pet0.webp", alt: "Nana" },
    { src: "/aboutMe/pet1.webp", alt: "Yiyi and Aria" },
    { src: "/aboutMe/pet2.webp", alt: "Aria" },
    { src: "/aboutMe/pet3.webp", alt: "Yuyuan" },
    { src: "/aboutMe/pet4.webp", alt: "Yiyi" },
    { src: "/aboutMe/pet5.webp", alt: "Aria" },
    { src: "/aboutMe/pet6.webp", alt: "Yuyuan" },
    { src: "/aboutMe/pet7.webp", alt: "Yiyi" },
    { src: "/aboutMe/pet8.webp", alt: "Yuyuan" },
    { src: "/aboutMe/pet9.webp", alt: "Yiyi" },
    { src: "/aboutMe/pet10.webp", alt: "Nana" },
  ];

  const photographyImages = galleryPhotos;

  return (
    <Layout maxWidth="max-w-6xl" bg="bg-primary-light dark:bg-primary-dark">
      <div className="max-w-6xl mx-auto">
        <div className="space-y-16 text-gray-700 dark:text-gray-300">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Fun Side of Life</h1>

          <div className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">I live with...</h2>

            <div className="grid grid-cols-4 gap-6 mb-6 mt-5">
              <div className="text-center mt-5">
                <img src="/aboutMe/scratch_nana.webp" alt="Nana" className="w-40 h-40 object-cover rounded-full  dark:shadow-gray-700 mb-3 mx-auto" />
                <p className="text-sm">Nana(8 yrs)</p>
                <p className="text-sm">all-day sleeper but food theft</p>
              </div>

              <div className="text-center mt-5">
                <img src="/aboutMe/scratch_aria.webp" alt="Aria" className="w-40 h-40 object-cover rounded-full dark:shadow-gray-700 mb-3 mx-auto" />
                <p className="text-sm">Aria(5yr)</p>
                <p className="text-sm">like warmer place</p>
              </div>
              <div className="text-center mt-5">
                <img src="/aboutMe/scratch_yuyuan.webp" alt="Yuyuan" className="w-40 h-40 object-cover rounded-full dark:shadow-gray-700 mb-3 mx-auto" />
                <p className="text-sm">Yuyuan(4 yrs)</p>
                <p className="text-sm">sweetest girl in the world</p>
              </div>
              <div className="text-center mt-5">
                <img src="/aboutMe/scratch_yiyi.webp" alt="Yiyi" className="w-40 h-40 object-cover rounded-full dark:shadow-gray-700 mb-3 mx-auto" />
                <p className="text-sm">Yiyi(2 yrs)</p>
                <p className="text-sm">independent and ball hunter</p>
              </div>
            </div>

            <div className="mb-4 mt-20 ">
              <Carousel images={familyImages} />
            </div>
          </div>

          <div className="mt-24">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">I am a big fan of...</h2>
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2 text-center">SHOHEI OHTANI</h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6 text-center">
              If you don't know this man, highly recommend you click this link{' '}
              <a 
                href="https://en.wikipedia.org/wiki/Shohei_Ohtani" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                https://en.wikipedia.org/wiki/Shohei_Ohtani
              </a>
            </p>
            <div className="bg-gray-50 dark:bg-gray-800 p-8 rounded-lg">
              <div className="text-center">
                <div className="text-6xl mb-4">⚾</div>
                <p className="text-lg text-gray-700 dark:text-gray-300 mb-4">
                  Watching this incredible two-way player redefine what's possible in baseball has been absolutely amazing. 
                  <br></br>
                  His dedication, skill, and humble attitude inspire me every day.
                </p>
                <p className="text-gray-600 dark:text-gray-400">
                  From his pitching dominance to his home run power, Shohei Ohtani represents the perfect blend of talent and hard work.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-24">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">Photography</h2>
            <div className="bg-gray-50 dark:bg-gray-800 p-8 rounded-lg">
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Capturing moments through the lens - a collection of my favorite shots from travels and daily life.
              </p>

              {photographyImages.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {photographyImages.map((image, index) => (
                    <div 
                      key={index} 
                      className="aspect-square overflow-hidden rounded-lg shadow-md cursor-pointer"
                      onClick={() => openModal(image)}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <p className="text-gray-500 dark:text-gray-400 text-lg">
                    Photography collection coming soon...
                  </p>
                  {/* <p className="text-gray-400 dark:text-gray-500 text-sm mt-2">
                    Add your photography images to the photographyImages array above
                  </p> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {isModalOpen && selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 overflow-hidden" onClick={closeModal}>
          <div className="w-full h-full p-4 flex gap-4" onClick={(e) => e.stopPropagation()}>
            {/* Other Photos Preview - Left Column */}
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg w-80 flex flex-col h-full">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">All Photos</h4>
              <div className="flex flex-col gap-3 flex-1 overflow-y-auto">
                {photographyImages.map((image, index) => (
                  <div
                    key={index}
                    className={`w-full h-20 cursor-pointer rounded-md overflow-hidden hover:ring-2 hover:ring-blue-500 transition-all flex-shrink-0 ${
                      image.src === selectedImage.src 
                        ? 'ring-2 ring-blue-500 opacity-100' 
                        : 'opacity-70 hover:opacity-100'
                    }`}
                    onClick={() => {
                      setSelectedImage(image);
                    }}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column - Image and Description */}
            <div className="flex-1 flex flex-col gap-4 h-full overflow-hidden">
              {/* Main Image - Top */}
              <div className="relative bg-black rounded-lg flex-1 flex items-center justify-center min-h-0">
                <button
                  onClick={closeModal}
                  className="absolute top-4 right-4 text-white text-3xl font-bold hover:text-gray-300 z-10"
                >
                  ×
                </button>
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  className="max-w-full max-h-full object-contain cursor-pointer"
                  onClick={closeModal}
                />
              </div>
              
              {/* Description Box - Bottom */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg flex-shrink-0 max-h-32 overflow-hidden">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                  {selectedImage.alt}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-lg">
                  {selectedImage.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Fun;